import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageToastService} from "../../../../../service/message-toast.service";
import {finalize, take} from "rxjs";
import {ApiResponse} from "../../../../../shared/model/response/ApiResponse";
import {ErrorMessageEnum} from "../../../../../shared/enums/error-message.enum";
import {AccountResponse} from "../../../../../shared/model/response/account-response.model";
import {UserRoleEnum} from "../../../../../shared/enums/user-role.enum";
import {roles} from "../../../../../shared/types/custom-types";
import {BaseUtil} from "../../../../../shared/utils/base.util";
import {AccountService} from "../../../../../service/api/account.service";

@Component({
    selector: 'app-admin-user-alter-privilege-modal',
    templateUrl: './admin-user-alter-privilege-modal.component.html',
    styleUrls: ['./admin-user-alter-privilege-modal.component.css'],
    standalone: false
})
export class AdminUserAlterPrivilegeModalComponent {

  @Input('user') user: AccountResponse
  @Input('display') displayModal: boolean

  @Output('onChanceSuccess') onChanceSuccess = new EventEmitter<AccountResponse>()
  @Output('onCancelModal') onCancelModal = new EventEmitter<any>()

  @Input('clickEvent')
  set clickEvent(user: AccountResponse) {
    this.roles = BaseUtil.removeFromStatus(roles(), [UserRoleEnum.MASTER, '', this.user.role.code])
  }

  form: FormGroup
  isLoading = false;

  roleError = null

  roles = []

  constructor(
    private accountService: AccountService,
    private messageToast: MessageToastService,
  ) {
  }

  ngOnInit(): void {
    this.roles = BaseUtil.removeFromStatus(roles(), [UserRoleEnum.MASTER, '', this.user.role.code])
    this.form = new FormGroup({
      "role": new FormControl(null, Validators.required),
    });
  }

  onSubmit() {
    if (this.form.invalid) this.validateFormErrors()
    else this.apiTerminateAccount()
  }

  apiTerminateAccount() {

    this.isLoading = true
    this.roleError = null

    this.accountService.updateRole({userId: this.user.id, role: this.form.get('role').value})
      .pipe(take(1), finalize(() => this.isLoading = false))
      .subscribe({
        next: value => {
          this.messageToast.success(value.message)
          this.onChanceSuccess.emit(value.data)
          this.onCancelModal.emit()
        },
        error: (err: ApiResponse<any>) => {
          this.messageToast.error(err?.message)

          if (err?.formErrors) {
            this.roleError = err.formErrors.get("role")
          }
        }
      })
  }

  validateFormErrors() {
    if (this.form.invalid) {
      if (this.form.get("role")?.hasError("required")) {
        this.roleError = ErrorMessageEnum.requiredField
      }
    }
  }
}
